import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Link from './Link'

const MapAttribution = props => {
  const [ open, setOpen ] = useState(false)

  return (
    <div
      className={[
        'text-black-50 d-flex flex-row-reverse align-items-end',
        'map-attribution',
        open ? 'map-attribution-open' : '',
      ].filter(Boolean).join(' ')}
    >
      <Link
        href="#attribution"
        className="map-attribution-summary text-black-50 px-1"
        onClick={() => setOpen(open => !open)}
      >
        <FontAwesomeIcon
          icon="plus"
          className="map-attribution-summary-indicator mr-1"
        />
        Map attribution
      </Link>

      <div className="map-attribution-body text-left px-1 ml-lg-3">
        <a
          href="https://commons.wikimedia.org/wiki/Special:Contributions/Theshibboleth"
          target="_blank"
        >Theshibboleth</a>, <a
          href="https://commons.wikimedia.org/wiki/File:Blank_US_Map_(states_only).svg"
          target="_blank"
        >Blank US Map (states only)
        </a>, Alaska and outlines removed, Hawaii moved to the left, and color
        changed by Pledge, <a
          href="https://creativecommons.org/licenses/by-sa/3.0/"
          rel="license"
          target="_blank"
        >CC BY-SA 3.0</a>
      </div>
    </div>
  )
}

export default MapAttribution
